import React from 'react';
import {Link} from '@reach/router';

import * as styles from './PlansList.module.css';

const MAX_DESCRIPTION_LENGTH = 50;

const formatMoney = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'usd',
}).format;

export function PlansList({plans}) {
  return (
    <ul className={styles.Container}>
      {plans.map(({plan}) => {
        const {id, title, description, priceCents} = plan;

        const formattedDescription =
          description.length > MAX_DESCRIPTION_LENGTH
            ? `${description.slice(0, MAX_DESCRIPTION_LENGTH).trim()}...`
            : description;

        return (
          <li className={styles.ItemContainer} key={id}>
            <Link to={`/plans/${id}`} className={styles.Item}>
              <p>
                <strong>{title}</strong>
              </p>
              <p>
                <small>
                  {formatMoney(priceCents / 100)} — {formattedDescription}
                </small>
              </p>
            </Link>
          </li>
        );
      })}
    </ul>
  );
}
